import { render, staticRenderFns } from "./xinwen.vue?vue&type=template&id=bf6a37c8&scoped=true&"
import script from "./xinwen.vue?vue&type=script&lang=js&"
export * from "./xinwen.vue?vue&type=script&lang=js&"
import style0 from "./xinwen.vue?vue&type=style&index=0&id=bf6a37c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6a37c8",
  null
  
)

export default component.exports